import { FirebaseDocRefType } from 'firebase/index'
import { useEffect, useState } from 'react'

const useQueryStoreName = (storeRef: FirebaseDocRefType | undefined) => {
  const [storeName, setStoreName] = useState<string>('')
  useEffect(() => {
    if (!storeRef) {
      setStoreName('')
      return
    }
    storeRef.get().then((snapshot) => {
      const data = snapshot.data()
      if (!data || !('name' in data)) {
        setStoreName('')
      } else {
        setStoreName(data.name)
      }
    })
  }, [storeRef])
  return storeName
}

export default useQueryStoreName
